goog.require('el8.template.multiuser_access.chooseAccount');
goog.require('el8.service.urls');
goog.require('el8.util.base');
goog.require('el8.uiwidget.Form');

var el8 = el8 || {};
if(!el8.multiuser_access) { el8.multiuser_access = {}; }

el8.multiuser_access.chooseAccount = (function() {

    var that = {};
    var theForm = null;

    that.init = function(spec) {
        /**
         * Initialize the global URL service
         */
        if (spec.urls) { el8.service.urls.init(spec.urls); }

        var physicians = spec.physicians;
        var staffs = spec.staffs;
        var users = physicians.concat(staffs);

        $('.main-content').html(
            el8.template.multiuser_access.chooseAccount.content({})
        );

        $('#account-chooser-container').html(
          el8.template.multiuser_access.chooseAccount.accountChooser({
            users: users,
            signupUrl: el8.service.urls.get('pageEnterName', [spec.faxCode])
          })
        );
    };

    return that;

})();
